import { createContext, useContext, useMemo, useState } from "react";

const SheetItemListValueContext = createContext();
const SheetItemListActionsContext = createContext();

export function SheetItemListContextProvider({ children }) {
    const [sheetItemList, setSheetItemList] = useState(null);

    const sheetItemListActions = useMemo(
        () => {
            return {
                onSet(newValues) {
                    setSheetItemList(newValues);
                },
                setValue: setSheetItemList
            }
        },
        []
    )

    return (
        <>
            <SheetItemListActionsContext.Provider value={{ sheetItemList: sheetItemListActions }}>
                <SheetItemListValueContext.Provider value={{ sheetItemList }}>
                    {children}
                </SheetItemListValueContext.Provider>
            </SheetItemListActionsContext.Provider>
        </>
    );
}

export function useSheetItemListValueContextHook(props) {
    const value = useContext(SheetItemListValueContext);

    if (value === undefined) {
        throw new Error('useSheetItemListValueContextHook should be used within SheetItemListValueContext');
    }

    return {
        sheetItemList: value.sheetItemList,
    };
}

export function useSheetItemListActionsContextHook(props) {
    const value = useContext(SheetItemListActionsContext);

    if (value === undefined) {
        throw new Error('useSheetItemListActionsContextHook should be used within SheetItemListActionsContext');
    }

    return {
        sheetItemList: {
            onSet: value.sheetItemList.onSet,
            setValue: value.sheetItemList.setValue
        },
    };
}